import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomHighchart extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  className: 'processing item custom-chart'
  defaultSize: ''

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @_settings.maximized = !!@_settings.maximized
    @container = @options.container
    @responsePostProcessor = @options.responsePostProcessor || @dummyResponsePostProcessor

  render: =>
    @$el.html(@template({
      title: @_settings.title
    }))
    if @_settings.maximized
      @$el.addClass('h2 w2')

  afterAppend: =>
    if @data
      @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current)) if @dataBenchmark
      @chart = new Highcharts.Chart(@chartOptions())
      @applyChartZoom()
      @trigger('masonry')
    else
      @ajaxCall(@getUrl(), @getAjaxData(), (response) =>
        @$el.removeClass('processing')
        @data = @responsePostProcessor(response)
        @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current)) if @dataBenchmark
        @chart = new Highcharts.Chart(@chartOptions())
        @applyChartZoom()
        @trigger('masonry')
      )

  getUrl: ->
    @url

  getAjaxData: ->
    @getSearchQuery().toJSON()

  dummyResponsePostProcessor: (response) =>
    response

  _previewSearch: (event) =>
    @createPreviewDashboard(@getNewQuery(event))

  _setDimension: (query, key, value) =>
    value = value[0] if key == 'gender'
    dimension = key.replace('filtered_', '')
    _.each ['tags', 'labels'], (field_name) =>
      if dimension == field_name
        dimension = if _.isEmpty(query.get("primary_#{field_name}")) then "primary_#{field_name}" else "secondary_#{field_name}"
    fieldsWithDefaultUndefined = ['min_followers', 'max_followers', 'geolocation']
    if (query.get(dimension) == undefined) && (!_.contains(fieldsWithDefaultUndefined, dimension)) # custom field
      customFacets = query.get('custom_facets')
      customKey = "custom_#{dimension}"
      customFacets[customKey] = value
      query.set('custom_facets', customFacets)
    else
      query.set(dimension, value)

  chartOptions: ->
    subtitle = I18n.t('monitoring.dashboard.charts.titles.current')
    options = {
      chart:
        plotBackgroundColor: null
        plotBorderWidth: null
        plotShadow: false
        renderTo: @$el.find('.chart')[0]
        marginTop: 50
      title: {text: null}
      legend:
        itemStyle:
          width: 120
          textOverflow: "wrap"
        itemWidth: 130
        align: 'right'
        layout: 'vertical'
        verticalAlign: 'middle'
        borderWidth: 0
      tooltip:
        followPointer: true
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
      exporting:
        buttons:
          contextButton:
            menuItems: []
            x: -14
      series: @series()
    }
    menuItems = @translatedItems(Highcharts.getOptions().exporting.buttons.contextButton.menuItems)
    menuItems = menuItems.concat({separator:true})
    unless window.sharedSession
      menuItems = menuItems.concat({
        text: if @_settings.maximized then I18n.t('monitoring.dashboard.charts.export_options.normal') else I18n.t('monitoring.dashboard.charts.export_options.maximize')
        onclick: (() => @toggleMaximize())
      })
    menuItems = menuItems.concat(@exportingOptions)
    options.exporting.buttons.contextButton.menuItems = menuItems

    $.extend(true, options, @customOptions())
    $.extend(true, options, @maximizedOptions()) if @_settings.maximized
    options

  maximizedOptions: ->
    {}

  toggleMaximize: =>
    @_settings.maximized = !@_settings.maximized
    if @_settings.maximized
      if @dataBenchmark
        @$el.addClass('w2 h2')
      else
        @$el.addClass('w2 h2')
    else
      @$el.removeClass('w2 h2')
      if @dataBenchmark
        @$el.addClass('w2')
      else
        @$el.addClass(@defaultSize)
    @trigger('chartsChange')
    @afterAppend()

  _translateName: (name) ->
    {
      labels: 'group'
      type: 'source'
    }[name] || name

  orderSeries: (series) ->
    _.sortBy( series, (serie) -> (serie.name || '').toLowerCase() )

  getValueForDimension: (dimension, point) ->
    definedValues = {'topics': [{name: point.name, id: point.code}]}
    defaultValue = [point.code]
    definedValues[dimension] || defaultValue
